import React from 'react';
import '../styles/Footer.css';

export function Footer(): JSX.Element {
  return (
    <footer className="site-footer" dir="rtl">
      <div className="site-footer__inner">
        <img src="/logo.png" alt="מטעמי העיר" className="site-footer__logo" />
        <div className="site-footer__contacts">
          <a href="tel:0506655641" className="site-footer__link">
            <span className="site-footer__icon">📞</span>
            050-6655641
          </a>
          <a
            href="https://wa.me/972506655641"
            className="site-footer__link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="site-footer__icon">💬</span>
            050-6655641
          </a>
          <a href="mailto:matamey14@gmail.com" className="site-footer__link">
            <span className="site-footer__icon">✉️</span>
            matamey14@gmail.com
          </a>
        </div>
      </div>
    </footer>
  );
}
